import React from "react";
import { FormItem } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { InfoIcon } from "lucide-react";

interface SimplifiedNumberFieldProps {
  value: string | number;
  onChange: (value: string) => void;
  label: string;
  description?: string;
  required?: boolean;
  videoUrl?: string;
}

export const SimplifiedNumberField: React.FC<SimplifiedNumberFieldProps> = ({
  value,
  onChange,
  label,
  description,
  required = false,
  videoUrl
}) => {
  return (
    <div className="w-full">
      <div className="flex items-center mb-2">
        <label className="text-slate-500 font-bold px-2">
          {label}{required && <span className="text-red-500">*</span>}
        </label>
        {description && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger><InfoIcon size={16} className="text-grey-light ml-1" /></TooltipTrigger>
              <TooltipContent>
                <p>{description}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      <Input 
        type="number"
        value={value} 
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-5 py-2.5 text-base placeholder:text-grey-light"
        placeholder={`Digite um valor numérico...`}
        required={required}
      />
    </div>
  );
}; 